import { useRef } from "react";

const useWindowManager = () => {
  const windowRefs = useRef({});
  const timeoutRefs = useRef({});

  const isElectron = () => {
    return true;
  };

  const openOrMessageWindow = (windowName, url, data) => {
    const inElectron = isElectron();

    if (inElectron) {
      // In Electron: always close and reopen the window
      if (windowRefs.current[windowName] && !windowRefs.current[windowName].closed) {
        console.log(`[Electron] Closing and reopening window: ${windowName}`);
        windowRefs.current[windowName].close();
      }
      windowRefs.current[windowName] = window.open(url, windowName);
      return;
    }

    // In Browser
    if (!windowRefs.current[windowName] || windowRefs.current[windowName].closed) {
      console.log(`[Browser] Opening new window: ${windowName}`);
      windowRefs.current[windowName] = window.open(url, windowName);
      return;
    }

    console.log(`[Browser] Checking existing window: ${windowName}`);
    windowRefs.current[windowName].postMessage({ type: "CHECK_URL" }, "*");

    const listener = (event) => {
      if (event.data?.type === "URL_OK" || event.data?.type === "LOADED") {
        console.log(`[Browser] Window '${windowName}' acknowledged. Focusing and messaging...`);
        windowRefs.current[windowName].focus();
        windowRefs.current[windowName].postMessage({ type: "INVOKE_METHOD", data: data }, "*");

        if (timeoutRefs.current[windowName]) {
          clearTimeout(timeoutRefs.current[windowName]);
          delete timeoutRefs.current[windowName];
        }
        window.removeEventListener("message", listener);
      }
    };

    window.addEventListener("message", listener);

    timeoutRefs.current[windowName] = setTimeout(() => {
      window.removeEventListener("message", listener);
      console.log(`[Browser] No acknowledgment for ${windowName}. Re-opening...`);
      windowRefs.current[windowName] = window.open(url, windowName);
    }, 500);
  };

  return { openOrMessageWindow };
};

export default useWindowManager;
